import {useQuery} from "@tanstack/react-query";
import {useRef} from "react";
import {StereotypeApiClient} from "../../../../../common/apis/stereotype/StereotypeApiClient";

export function useLayoutDefinitionQuery(stereotypeId: string | undefined, layoutId: string | undefined) {
    const stereotypeApiClient = useRef(new StereotypeApiClient());

    return useQuery({
        queryKey: ["stereotypes.stereotype", stereotypeId, "layout-definition", layoutId],
        queryFn: () => stereotypeApiClient.current.findLayout(stereotypeId!, layoutId!),
        enabled: !!stereotypeId && !!layoutId,
    });
}